export enum ActionTypes {
    ListCustomers = 'customers.list',
    DeleteCustomer = 'customers.delete',
    UpdateIsCustomerPopupOpen = 'customers.isCustomerPopupOpen.update',
    UpdateIsCustomerSuccessOpen = 'customers.isCustomerSuccessOpen.update',
}
